
var lazyloadLess = {};
import genaration from '../../utils/classname';
export var lazyloadClass = genaration(lazyloadLess, 'lazyload');